import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const archivedIssuesEntrypoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() => import(/* webpackChunkName: "async-archived-issues-entrypoint" */ './src'),
	),
	getPreloadProps: () => ({}),
});
